import { Field, Float, ID, InputType, ObjectType } from 'type-graphql'
import type { IAction } from '../../action/IAction'
import { ActionArgs } from '../../action/ActionArgs'
import { MatchedDocument } from '../../document-asset/MatchedDocument'

@InputType()
export class AnalyzeImageForDocumentCodeArgs extends ActionArgs {
  @Field(() => ID)
  id: string

  @Field(() => String)
  imageUrl: string
}

@ObjectType()
@InputType('AnalyzeImageForDocumentCodeResultInput')
export class AnalyzeImageForDocumentCodeResult {
  @Field(() => ID)
  id: string

  @Field(() => [String])
  documentCodes: string[]

  @Field(() => Float)
  confidence: number

  @Field(() => [MatchedDocument])
  matchedDocuments: MatchedDocument[]

  @Field(() => Boolean)
  shouldAutoAttach: boolean

  @Field(() => String, { nullable: true })
  errorMessage?: string
}

export interface IAnalyzeImageForDocumentCode extends IAction<
  AnalyzeImageForDocumentCodeResult,
  AnalyzeImageForDocumentCodeArgs
> {}
